// extracted by mini-css-extract-plugin
export default {"botoneraCuadroDatos":"CuadroEditable_botoneraCuadroDatos__xNO8d","botonCuadroDatos":"CuadroEditable_botonCuadroDatos__gxx9o"};